import type { SVGProps } from 'react';

export const ArrowFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='9'
    height='7'
    fill='none'
    viewBox='0 0 9 7'
    {...props}
  >
    <path
      fill='#424242'
      d='M.563 0a.562.562 0 0 0-.45.9l3.75 5a.563.563 0 0 0 .9 0l3.75-5a.562.562 0 0 0-.45-.9z'
    ></path>
  </svg>
);
